import { InformationCircleIcon } from "@heroicons/react/24/outline";
import Modal from "./modal";
import { useTranslation } from "react-i18next";

interface BrokerPermissionModalProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    brokerName: string;
}

const BrokerPermissionModal = ({
    open,
    setOpen,
    brokerName,
}: BrokerPermissionModalProps) => {
    const { t } = useTranslation();
    const displayName = brokerName.toUpperCase();

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            title={t("broker_permission.title")}
            size="sm">
            <div className="flex flex-col items-center gap-4 py-4 text-center">
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-50">
                    <InformationCircleIcon className="w-7 h-7 text-blue-500" />
                </div>
                <p className="text-gray-700 text-sm">
                    {t("broker_permission.message", { broker: displayName })}
                </p>
                <button
                    onClick={() => setOpen(false)}
                    className="mt-2 px-5 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                    OK
                </button>
            </div>
        </Modal>
    );
};

export default BrokerPermissionModal;
